import React, { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { Icon, Button, Modal } from '@arnsbogroup/react-voicearchive'
import classNames from 'classnames'
import NiceModal, { useModal } from '@ebay/nice-modal-react'


const ErrorsModal = NiceModal.create(({ errors }) => {
  const modal = useModal()
  return (
    <Modal
      show={modal.visible}
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      onSubmit={() => {
        modal.resolve()
        modal.remove()
      }}
      dialogPanelClasses="max-w-xl overflow-x-scroll"
    >
      <div className="space-y-4">
        <h2 className="font-medium">
          The following warnings were found when trying to close the order. Please review before proceeding.
        </h2>

        <ul>
          { errors.map((error, index) => (
            <li>{ error }</li>
          )) }
        </ul>

        <h4 className="font-medium">
          Do you want to ignore the warnings and close the order anyway?
        </h4>

        <div className="flex justify-between items-center">
          <Button onClick={() => modal.remove()} >
            Cancel
          </Button>

          <Button
            variant="outline"
            state="negative"
            onClick={() => {
              modal.resolve()
              modal.remove()
            }}
          >
            Yes, proceed to close
          </Button>
        </div>
      </div>
    </Modal>
  )
})

export default ({ order, readOnly, refetch, as = null, ...props }) => {
  const [loading, setLoading] = useState(false)
  const Component = as || Button

  const onValidate = () => {
    setLoading(true)

    fetch(`/order/validate.json?id=${order.uid}`)
      .then((response) => response.json())
      .then(({ success, errors }) => {
        setLoading(false)

        if (success) {
          onClose()
        } else {
          NiceModal
            .show(ErrorsModal, { errors })
            .then(onClose)
        }
      })
      .catch((error) => toastr.error(error))
  }

  const onClose = () => {
    setLoading(true)

    const body = new FormData()
    body.append('orderid', order.uid)

    fetch(`/order/closeOrder.json`, { method: 'POST', body })
      .then((response) => response.json())
      .then(({ success, errors }) => {
        setLoading(false)

        if (success) {
          return refetch()
        } else {
          toastr.error(errors.join(', '))
        }
      })
      .catch((error) => toastr.error(error))
  }

  const onReopen = () => {
    setLoading(true)

    const body = new FormData()
    body.append('orderid', order.uid)

    fetch(`/order/reopenOrder.json`, { method: 'POST', body })
      .then((response) => response.json())
      .then(({ success, errors }) => {
        setLoading(false)

        if (success) {
          return refetch()
        } else {
          toastr.error(errors.join(', '))
        }
      })
      .catch((error) => toastr.error(error))
  }

  return !!order.closed ? (
    <Component size="sm" {...props} disabled={loading} onClick={onReopen}>
      { loading ? (
        <span>Re-opening..</span>
      ) : (
        <span>Re-open</span>
      ) }
    </Component>
  ) : (
    <Component size="sm" {...props} disabled={readOnly || loading} onClick={onValidate}>
      { loading ? (
        <span>Closing..</span>
      ) : (
        <span>Close</span>
      ) }
    </Component>
  )
}
